const getUserAccess = (value) => {
  if (value === null || value === undefined || value.length <= 0) {
    return '';
  }

  const lowerCaseValue = value.toLowerCase();

  if (lowerCaseValue === 'sticky-context') {
    return 'Persistent Access';
  }
  if (lowerCaseValue === 'context') {
    return 'Enrolled Access';
  }

  return '';
};

export default getUserAccess;
